'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, Utensils, Leaf, Activity, Layers } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';
import { useAuth } from '@/contexts/AuthContext';

const tabs = [
  { label: 'Home', href: '/', icon: LayoutDashboard, adminOnly: false },
  { label: 'Feed', href: '/feeding-bedding-log', icon: Utensils, adminOnly: false },
  { label: 'ANC', href: '/anc-system', icon: Layers, adminOnly: false },
  { label: 'Harvest', href: '/harvest-records', icon: Leaf, adminOnly: false },
  { label: 'Log', href: '/activity-feed', icon: Activity, adminOnly: true },
];

export default function BottomTabBar() {
  const pathname = usePathname();
  const { isAdmin } = useAuth();

  const visibleTabs = tabs?.filter((tab) => !tab?.adminOnly || isAdmin);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border">
      <div className="flex items-stretch h-[60px] max-w-screen-2xl mx-auto">
        {visibleTabs?.map((tab) => {
          const Icon = tab?.icon;
          const isActive =
            tab?.href === '/' ? pathname === '/' : pathname?.startsWith(tab?.href);
          return (
            <Link
              key={`tab-${tab?.label}`}
              href={tab?.href}
              className={`flex-1 flex flex-col items-center justify-center gap-1 transition-colors ${
                isActive
                  ? 'text-primary' :'text-muted-foreground active:text-foreground'
              }`}
            >
              <div
                className={`p-1.5 rounded-lg transition-colors ${
                  isActive ? 'bg-secondary' : ''
                }`}
              >
                <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
              </div>
              <span className={`text-[11px] font-semibold leading-none ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>
                {tab?.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}